<template>
  <div>
    <div>
      <h3 class="title-color">Installer Details</h3>
    </div>
    <div class="e-card-separator"></div>
    <div class="main-container">
      <address-info
        @updateAddress="updateInstallerCompanyAddress"
        :company="permit.installerCompany"
        @updateCompanyLegalName="updateInstallerCompanyLegalName"
        :applier="installer"
        @updateContactFieldDS="
          updateContactFieldDS(
            $event,
            'installerContactFieldDataSource',
            'installerContact'
          )
        "
      />

      <div class="e-card-separator"></div>

      <contact-info
        ref="installerContactRef"
        @updateContactNumber="updateInstallerContactNumber"
        @updateContactInfo="updateInstallerName"
        :phoneRules="[phoneRule]"
        :emailRules="[emailRule]"
        :applier="installer"
        :contact="permit.installerContact"
        :contactFieldDataSource="installerContactFieldDataSource"
      />

      <div class="e-card-separator"></div>

      <div class="sub-container">
        <div class="form-row-input">
          <ejs-textbox
            float-label-type="Always"
            placeholder="CPCA ID:"
            v-model="permit.installerContact.cpcaId"
            :maxlength="50"
            @input="onChanging"
          />
        </div>

        <div class="form-row-input">
          <ejs-textbox
            float-label-type="Always"
            placeholder="TSSA ID:"
            v-model="permit.installerContact.tssaId"
            :maxlength="50"
            @input="onChanging"
          />
        </div>

        <div class="form-row-input">
          <ejs-textbox
            float-label-type="Always"
            placeholder="PTMAA ID:"
            v-model="permit.installerContact.ptmaaId"
            :maxlength="50"
          />
        </div>

        <div
          class="form-row-input"
          style="grid-column: span 3"
          ref="installerDetailsComments"
        >
          <ejs-textbox
            float-label-type="Always"
            placeholder="Please indicate qualification(s)/experience as
            it relates to the scope of work: "
            :multiline="true"
            v-model="permit.installerContact.comments"
            :maxlength="250"
            @input="onChanging"
          />
          <label v-if="showCommentsValidation" class="e-error"
            >CPCA or TSSA ID or comment is required</label
          >
        </div>
      </div>
    </div>

    <div>
      <h3 class="title-color">Engineer Details</h3>
    </div>
    <div class="main-container">
      <address-info
        @updateAddress="updateEngineerCompanyAddress"
        @updateCompanyLegalName="updateEngineerCompanyLegalName"
        :company="permit.engineerCompany"
        :applier="engineer"
        @updateContactFieldDS="
          updateContactFieldDS(
            $event,
            'engineerContactFieldDataSource',
            'engineerContact'
          )
        "
      />
      <div class="e-card-separator"></div>
      <contact-info
        ref="engineerContactRef"
        :showRegNo="true"
        @updateContactNumber="updateEngineerContactNumber"
        @updateContactInfo="updateEngineerName"
        :phoneRules="[phoneRule]"
        :emailRules="[emailRule]"
        :applier="engineer"
        :contact="permit.engineerContact"
        :contactFieldDataSource="engineerContactFieldDataSource"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import addressInfo from './common/address-info.vue';
import { applierTypeEnum } from './constants';
import ContactInfo from './common/contact-info.vue';
import { emailRule, phoneRule, requiredRule } from '../../../shared/constants';
import { getEServicesContacts } from '../../auth/services/tms-api';
// import SccInputValidator from '../../../components/base/scc-input-validator.vue';
import {
  updateContactFieldDS,
  updateContactNumber,
  updateContactInfo,
} from './helper';

export default {
  components: { addressInfo, ContactInfo },
  name: 'InstallerDetails',
  data() {
    return {
      installer: applierTypeEnum.INSTALLER,
      engineer: applierTypeEnum.ENGINEER,
      phoneRule,
      emailRule,
      requiredRule,
      installerContactFieldDataSource: null,
      engineerContactFieldDataSource: null,
      showCommentsValidation: false,
    };
  },
  computed: {
    ...mapGetters({
      permit: 'permit',
    }),
  },
  watch: {
    async permit(val) {
      if (val && val.engineerCompany && val.engineerCompany.sourceCompanyId && !this.engineerContactFieldDataSource) {
        if (val.engineerCompany.sourceCompanyId) {
          await getEServicesContacts(val.engineerCompany.sourceCompanyId).then((res) => {
            // eslint-disable-next-line no-return-assign, no-param-reassign
            res.data.forEach((x) => (x.name = `${x.fName} ${x.lName}`));
            this.engineerContactFieldDataSource = res.data;
          });
        } else {
          this.engineerContactFieldDataSource = null;
        }
      }
      if (val && val.installerCompany && val.installerCompany.sourceCompanyId && !this.installerContactFieldDataSource) {
        if (val.engineerCompany.sourceCompanyId) {
          await getEServicesContacts(val.installerCompany.sourceCompanyId).then((res) => {
            // eslint-disable-next-line no-return-assign, no-param-reassign
            res.data.forEach((x) => (x.name = `${x.fName} ${x.lName}`));
            this.installerContactFieldDataSource = res.data;
          });
        } else {
          this.installerContactFieldDataSource = null;
        }
      }
    },
  },
  methods: {
    onChanging(e) {
      if (e.value) {
        this.$refs.installerDetailsComments.classList.remove('e-error');
        this.showCommentsValidation = false;
      }
    },
    updateEngineerCompanyAddress(address) {
      this.permit.engineerCompany = address;
    },
    updateInstallerCompanyAddress(address) {
      this.permit.installerCompany = address;
    },
    updateEngineerContactNumber(data) {
      updateContactNumber(data, this.permit.engineerContact);
    },
    updateInstallerContactNumber(data) {
      updateContactNumber(data, this.permit.installerContact);
    },
    updateContactFieldDS(dataSource, prop, contact) {
      updateContactFieldDS(this, dataSource, this.permit[contact], prop);
    },
    updateInstallerName(data) {
      updateContactInfo(data, this.permit.installerContact);
    },
    updateEngineerName(data) {
      updateContactInfo(data, this.permit.engineerContact);
    },
    updateInstallerCompanyLegalName(name) {
      this.permit.installerCompany.legalName = name;
    },
    updateEngineerCompanyLegalName(name) {
      this.permit.engineerCompany.legalName = name;
    },
  },
};
</script>
